import { appNoOp, onError } from '@actions/app.action';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  map,
  mergeMap,
} from 'rxjs/operators';
import { BaseError, ErrorType } from '@models/app.models';
import { createInvoice } from '@actions/invoice.action';
import { InvoiceService } from '@services/api-clients/invoice.service';
import getFilename from '@utils/getFilename';
import { saveAs } from 'file-saver';

@Injectable()
export class InvoiceEffect {
  constructor(
    private actions$: Actions,
    private invoiceService: InvoiceService,
  ) { }
  createInvoice$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        createInvoice
      ),
      mergeMap((action) =>
        this.invoiceService.createInvoice(action.payload).pipe(
          map((result) =>{
            if (result.body) {
              saveAs(result.body, getFilename(result));
            }
            return appNoOp();
          }),
          catchError(() =>
            of(
              onError({
                error: new BaseError(ErrorType.InvoiceCreationError),
              }),
            ),
          ),
        ),
      ),
    )
  }
  );

}
